import { render, staticRenderFns } from "./CardUserChildren.vue?vue&type=template&id=155171c4"
import script from "./CardUserChildren.vue?vue&type=script&lang=js"
export * from "./CardUserChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports